"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A000",
  fillRule: "evenodd",
  d: "M9.959 16.998a.463.463 0 0 1-.22-.078l-.029-.02a.468.468 0 0 1-.18-.37v-1.215c0-.259.21-.468.47-.468h.032a.47.47 0 0 1 .437.469v1.215c0 .112-.04.215-.106.296l-.023.026-.025.024A.468.468 0 0 1 10 17l-.041-.002Zm-4.05-3.57a.469.469 0 1 1 .664.662l-.86.86a.466.466 0 0 1-.663 0 .469.469 0 0 1 0-.664l.86-.859Zm7.52.001a.467.467 0 0 1 .661 0l.86.86a.467.467 0 1 1-.661.66l-.86-.859a.467.467 0 0 1 0-.66ZM4.684 9.531a.47.47 0 0 1 0 .938H3.47a.469.469 0 0 1 0-.938h1.215Zm11.848.002a.467.467 0 1 1 0 .934h-1.215a.467.467 0 1 1 0-.934h1.215ZM5.05 5.05a.469.469 0 0 1 .663 0l.86.86a.47.47 0 0 1-.664.663l-.859-.86a.469.469 0 0 1 0-.663Zm9.239 0a.467.467 0 0 1 .66.661l-.859.86a.466.466 0 0 1-.661 0 .468.468 0 0 1 0-.661l.86-.86ZM9.998 3l.033.001a.463.463 0 0 1 .062.009l.033.008a.469.469 0 0 1 .342.451v1.216a.47.47 0 0 1-.47.469l-.031-.001a.469.469 0 0 1-.437-.468V3.469a.47.47 0 0 1 .375-.46l.03-.005A.47.47 0 0 1 10 3Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A000",
  d: "M13.5 10a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SunnyIcon20.js.map